import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_LINKED_CREDIT_ACCOUNT } from 'actions/apiActionConstants'
import requestLoyaltyLinkedCreditAccount from 'api/loyalty/requestLoyaltyLinkedCreditAccount'

function fetchLoyaltyLinkedCreditAccount(businessId?: string, token?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const linkedCreditAccount = state.loyalty.linkedCreditAccount

    if (
      !businessId ||
      linkedCreditAccount.data ||
      linkedCreditAccount.data === null || // null means the fetch was successful but the employee has no loyalty account
      linkedCreditAccount.fetching ||
      linkedCreditAccount.error
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_LINKED_CREDIT_ACCOUNT,
      request: () => requestLoyaltyLinkedCreditAccount(businessId, token),
    })
  }
}

export default fetchLoyaltyLinkedCreditAccount
